import { DEVICE_ACCESS_DENIED_MESSAGE } from './constants'
import { useDeviceAccessDenied } from '@data/device/device'

// Sits beside a device picker to explain an empty list the user cannot act on.
//
// The pickers are disabled when they have no options, which means react-select's
// `noOptionsMessage` and Mantine's `nothingFoundMessage` can never be opened — the
// explanation has to render outside the control to be reachable at all.
//
// Renders nothing when the user has device access, so it is safe to drop in
// unconditionally next to any picker.
const DeviceAccessNotice = () => {
  const accessDenied = useDeviceAccessDenied()

  if (!accessDenied) return null

  return (
    <div
      className='text-muted small mt-1'
      role='status'
    >
      {DEVICE_ACCESS_DENIED_MESSAGE}
    </div>
  )
}

export default DeviceAccessNotice
